import { render } from "./PartnersRegisterView.vue?vue&type=template&id=cbdc4ec8&scoped=true"
import script from "./PartnersRegisterView.vue?vue&type=script&lang=js"
export * from "./PartnersRegisterView.vue?vue&type=script&lang=js"

import "./PartnersRegisterView.vue?vue&type=style&index=0&id=cbdc4ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdc4ec8"]])

export default __exports__